import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationSection from './ConfirmationSection';

const ConfirmationHousingSituation = ({ formData }) => {
  const answer = formData?.isCurrentlyHomelessOrIsAtRiskOfBecomingHomeless;
  if (typeof answer !== 'boolean') return null;

  return (
    <ConfirmationSection
      title="Your housing situation"
      rows={[
        {
          label: 'Are you homeless or at risk of becoming homeless?',
          value: answer ? 'Yes' : 'No',
        },
      ]}
    />
  );
};

ConfirmationHousingSituation.propTypes = {
  formData: PropTypes.shape({
    isCurrentlyHomelessOrIsAtRiskOfBecomingHomeless: PropTypes.bool,
  }),
};

export default ConfirmationHousingSituation;
